import { Button, Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../scss/business-styling-component/choose-invozio-for-your-business.style.scss";

export interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface ChooseSectionProps {
  image: string;
  imageAlt: string;
  title: string;
  description: string;
  features: Feature[];
  buttonText?: string;
  navigateToRoute?: (swedishPath: string, EnglishPath: string) => void;
  isReadMore?: boolean

}

export const WhyChooseInvozioSection = ({
  image,
  imageAlt,
  title,
  description,
  features,
  buttonText,
  navigateToRoute,
  isReadMore = true
}: ChooseSectionProps) => {
  const BOOTSTRAP_MD_BREAKPOINT = 768;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container className="padding-140-choose-invozio">
      <Row className={`choose-invozio-row ${isLargeScreen ? "large-screen" : ""}`}>
        {!isMobile && (
          <Col md={6} className="px-0 half-stretch">
            <img src={image} alt={imageAlt} className="choose-invozio-image" />
          </Col>
        )}
        <Col md={6} className="choose-invozio-content-col px-0">
          <div className={`choose-invozio-content${isLargeScreen ? " large" : ""}`}>
            <h2 className="choose-invozio-title">{title}</h2>
            {isReadMore ? <p className="choose-invozio-description">{description}</p> : ''}
            {isMobile ? <img src={image} alt={imageAlt} className="choose-invozio-image" /> : null}
            <Row>
              {features.map(({ icon, title, description }, idx) => (
                <Col md={12} key={idx} className="choose-invozio-feature-col px-0 pr-sm-5">
                  <div>
                    <div className=" choose-invozio-feature-row">
                      <div className="choose-invozio-feature-icon">
                        <img src={icon} alt={title} />
                      </div>
                      <div className="choose-invozio-feature-title-wrap">
                        <h3 className="choose-invozio-feature-title mb-0">{title}</h3>
                      </div>
                    </div>
                    <p className="choose-invozio-feature-description mb-0">{description}</p>
                  </div>
                </Col>
              ))}
              {isReadMore ? <>
                <div className={`d-flex justify-content-strart w-100 employees-work-btn-main-div ${isLargeScreen ? '' : 'w-50 rounded'}`}>
                  <Button
                    size="sm"
                    className={`employees-work-btn border-2 ${isLargeScreen ? '' : 'py-2 px-3'} readMore-btn-choose-invozio align-items-start gap-2`}
                    onClick={() => navigateToRoute && navigateToRoute("invoice-without-company-or-business", "fakturera-utan-foretag-eller-bolag")}
                  >
                    {buttonText}
                  </Button>
                </div>
              </> : ''
              }
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
